import './home.css';

export default function Home() {
    return (
        <div className="home-content">
            <div className="home-text">
                <h1>We are SWAN!</h1>
                <h2>We work with children, young people and families.</h2>
                <h2>Together we can have a bigger impact.</h2>
            </div>
            <div className="home-image">
                <img alt="The SWAN team." src="../../images/content/park1.jpg" />
            </div>
        </div>
    )
}